import * as Sentry from "@sentry/react";
const env = import.meta.env.MODE;

const log = {
  error: (error, context) => {
    try {
      if (env !== "production") {
        if (context) console.error(error, context);
        else console.error(error);
        return;
      }

      let exception = error;
      let extra = context;

      if (typeof error === "string") {
        if (context instanceof Error) {
          exception = context;
          extra = { message: error };
        } else {
          Sentry.captureMessage(error, context ? { extra: context } : undefined);
          return;
        }
      }

      Sentry.captureException(exception, extra ? { extra } : undefined);
    } catch (err) {
      console.error("Failed to capture exception:", err);
    }
  },
  message: (text, context) => {
    try {
      if (env !== "production") {
        if (context) console.log(text, context);
        else console.log(text);
      } else {
        Sentry.captureMessage(text, context ? { extra: context } : undefined);
      }
    } catch (err) {
      console.error("Failed to capture message:", err);
    }
  },
};

window.$log = log;
